import { asyncQueue } from 'utils/ApiUtils';
import { generateGuid } from 'utils/Guid';

export interface IQueueUtilOptions {
  callback: () => Promise<any>;
  useLastRequestedPromise?: boolean;
}

/**
 * Need this wrapper class for MVC
 */
export class QueueUtil {
  private id: string;
  constructor() {
    this.id = generateGuid();
  }
  public enqueue(option: IQueueUtilOptions) {
    return asyncQueue({ id: this.id, ...option });
  }
}
